import lazyLoad from '@utils/lazyLoad'

const orderRoutes = [
  {
    path: '/orderManagement/orders', // 全部订单
    exact: true,
    component: lazyLoad(() => import('@views/AppMails/OrderManagement/Orders')),
    meta: {
      title: '全部订单',
      layoutMode: 'empty'
    }
  },
  {
    path: '/orderManagement/backsheets', // 退单
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/OrderManagement/Backsheets')
    ),
    meta: {
      title: '退单',
      layoutMode: 'empty'
    }
  },
  {
    path: '/orderManagement/backsheets/detail/:id', // 退单详情
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/OrderManagement/Backsheets/Detail')
    ),
    meta: {
      title: '退单详情',
      layoutMode: 'empty'
    }
  },
  {
    path: '/orderManagement/detail/:id', // 退单
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/OrderManagement/Orders/Detail')
    ),
    meta: {
      title: '订单详情'
    }
  }
]

export default orderRoutes
